<template>
  <section class="hero is-dark">
    <div class="hero-body">
      <div class="container">
        <div class="columns">

        </div>
        <div class="columns">
          <div class="column is-12">
            <p class="has-text-centered">
              Car-Trackr.com © {{ year }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>

</style>
